import { render, staticRenderFns } from "./chapterQuestion.vue?vue&type=template&id=6315763c&scoped=true"
import script from "./chapterQuestion.vue?vue&type=script&lang=js"
export * from "./chapterQuestion.vue?vue&type=script&lang=js"
import style0 from "./chapterQuestion.vue?vue&type=style&index=0&id=6315763c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6315763c",
  null
  
)

export default component.exports